module.exports = __webpack_public_path__ + "static/media/一种融合用户多生物特征的活体认证支付系统.d1025ef0.png";